var _path, _g, _circle, _circle2, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgPaymentIcon = function SvgPaymentIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 31,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "PaymentIcon_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 40,
    height: 31
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.313.269h33.114a3.314 3.314 0 0 1 3.314 3.313v3.31H0v-3.31A3.313 3.313 0 0 1 3.313.269ZM.968 29.105A3.307 3.307 0 0 1 0 26.767V13.515h39.74v13.252a3.307 3.307 0 0 1-3.306 3.306H3.306a3.307 3.307 0 0 1-2.338-.968Z",
    fill: "#000"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#PaymentIcon_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0D66FC",
    d: "M-1 10.429h41.508v19.5H-1z"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6.021,
    cy: 23.633,
    r: 2.653,
    fill: "#F8CFFF"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.146,
    cy: 23.633,
    r: 2.653,
    fill: "#F8CFFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.293 1.241h18.578-18.578Zm0 0H.871h19.422ZM20.293 5.198h18.578-18.578Zm0 0H.871h19.422Z",
    stroke: "#2576FF",
    strokeWidth: 1.499,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

export default SvgPaymentIcon;